var exports = {
  "k": "container__jEdmIL",
};

module.exports = exports;
